import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { ReservationFamily, ReservationFamilyBulkCreateInput
    , ReservationFamilyBulkCreateBackgroundJobResult } from './reservation-family.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class ReservationFamilyService extends AbstractEntityService {

    protected resourceUrl = 'api/reservation-families';
    private resourceSearchUrl = 'api/_search/reservation-families';
    protected resourceCountUrl = 'api/_search/count/reservation-families';
    private resourceBulkUrl = 'api/background-jobs/reservation-families';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(reservationFamily: ReservationFamily): Observable<ReservationFamily> {
        let copy: ReservationFamily = Object.assign({}, reservationFamily);
        copy.startDate = this.dateUtils.toDate(reservationFamily.startDate);
        copy.endDate = this.dateUtils.toDate(reservationFamily.endDate);
        return this.http.post<ReservationFamily>(this.resourceUrl, copy).map((res: ReservationFamily) => {
            return res;
        });
    }

    bulkCreate(bulkCreateInput: ReservationFamilyBulkCreateInput): Observable<string> {
        return this.http.post<string>(this.resourceBulkUrl
            , bulkCreateInput).map((res: string) => {
            return res;
        });
    }

    getBulkCreateResult(idempotencyKey: string): Observable<ReservationFamilyBulkCreateBackgroundJobResult> {
        return this.http.get<ReservationFamilyBulkCreateBackgroundJobResult>(`${this.resourceBulkUrl}/${idempotencyKey}/status`)
                        .map((res: ReservationFamilyBulkCreateBackgroundJobResult) => {
                            return res;
                        });
    }

    update(reservationFamily: ReservationFamily): Observable<ReservationFamily> {
        let copy: ReservationFamily = Object.assign({}, reservationFamily);

        return this.http.put<ReservationFamily>(this.resourceUrl, copy).map((res: ReservationFamily) => {
            return res;
        });
    }

    find(id: number): Observable<ReservationFamily> {
        return this.http.get<ReservationFamily>(`${this.resourceUrl}/${id}`).map((res: ReservationFamily) => {
            let jsonResponse = res;
            jsonResponse.startDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.startDate);
            jsonResponse.endDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.endDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<ReservationFamily[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ReservationFamily[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<ReservationFamily[]>) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<ReservationFamily[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ReservationFamily[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<ReservationFamily[]>) => this.convertResponse(res))
            ;
    }

    private convertResponse(res: HttpResponse<ReservationFamily[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].startDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].startDate);
            jsonResponse[i].endDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].endDate);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family.service.ts